<template>
  <div
    class="bg-image"
    :style="{
      'background-image': 'url(' + require('@/assets/background.webp') + ')',
    }"
  >
    <div class="auth-container container-fluid">
      <div class="page-wrapper">
        <img
          class="login-header"
          src="../../../static/logo.svg"
          alt="Lontex B2B"
        />
        <auth-form />
        <footer class="login-footer">
          <a href="https://www.sapbusinessone.pl/"
            >wykonane przez SOFT TEAM Consulting Sp. z o.o.</a
          >
        </footer>
      </div>
    </div>
  </div>
</template>
<style scoped>
body {
  color: #373330;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.36;
  font-size: 1.4rem;
  background-color: #373330;
}
.login-header {
  margin: 3rem 0 3rem;
  width: 100%;
}
.page-wrapper {
  -webkit-flex-grow: 0;
  flex-grow: 0;
  -webkit-flex-shrink: 0;
  flex-shrink: 0;
  border: 1px solid #e3e3e3;
  box-shadow: 0 5px 30px 0 #000000;
  display: block;
  float: none;
  margin: auto;
  max-width: 28rem;
  min-height: 30rem;
  min-width: 0;
  padding: 40px 80px 50px;
  position: relative;
  width: 100%;
  z-index: 1;
  background-color: black;
  left: 25%;
  opacity: 0.8;
}
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

html {
  background-color: #373330;
}
.login-footer a {
  color: #989287;
  font-weight: 400;
  left: 0;
  margin: 5rem 0 2rem;
  position: absolute;
  text-align: center;
  top: 100%;
  width: 100%;
  font-size: 10px;
}
.bg-image {
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

@media only screen and (max-width: 576px) {
  .page-wrapper {
    padding: 20px 40px 25px;
  }
}
</style>
<script>
export default {
  name: "AuthPage",
  components: {
    AuthForm: () => import("./components/AuthForm"),
  },
};
</script>
